import React, { useEffect } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import tabId from 'services/tabId';
import { ApplicationState } from 'store';
import { ProfileState, ProfileTypes } from 'store/modules/profile_store/types';
import Onboarding from 'components/molecules/onboarding';
import { hasCookie } from 'services/actions/cookies_actions';
import colors from 'styles/colors';
import { getUserContacts } from 'store/modules/user_contacts_store/actions';
import companyId from 'services/company_id';

interface CompanySelectNewProps {
  callbackSelect: () => void;
}

const CompanySelectNew = (props: CompanySelectNewProps) => {
  const { callbackSelect } = props;
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const dispatch = useDispatch();

  useEffect(() => {
    tabId();
    callbackSelect();
  }, []);

  useEffect(() => {
    dispatch(getUserContacts(companyId(profile)));
  }, [profile.currentCompany[tabId()]]);

  const selectStyle = () => {
    return {
      control: (styles: any) => ({
        ...styles,
        background: colors.$japanese_indigo,
      }),
      singleValue: (styles: any) => ({
        ...styles,
        color: 'white',
      }),
      option: (styles: any) => ({
        ...styles,
        color: 'black',
      }),
    };
  };

  return (
    <div className="representant-select order-3 order-md-2 d-flex align-items-center">
      <span className="px-3 text-white">Empresa:</span>
      <Select
        styles={selectStyle()}
        className="filter-input flex-grow-1 tour-select-company"
        value={{
          label:
            profile?.represented.filter(
              (company) => company?.id === profile?.currentCompany[tabId()],
            )[0]?.nome_fantasia || profile.represented[0].nome_fantasia,
          value:
            profile?.represented.filter(
              (company) => company?.id === profile?.currentCompany[tabId()],
            )[0]?.id || profile.represented[0].id,
        }}
        onChange={(value) => {
          dispatch({
            type: ProfileTypes.UPDATE_CURRENT_COMPANY,
            companyId: Number(value?.value),
            tabId: tabId(),
          });
          window.location.reload();
        }}
        onFocus={() => callbackSelect()}
        options={profile.represented.map((company) => {
          return {
            label: company.nome_fantasia,
            value: company.id,
          };
        })}
      />
      {!hasCookie('onboardingRepresented') && <Onboarding tourSelect="onboardingRepresented" />}
    </div>
  );
};

export default CompanySelectNew;
